// eslint-disable-next-line no-shadow
export enum TransitionDuration {
  Fast = '100ms',
  Normal = '200ms',
  Slow = '300ms',
}

// eslint-disable-next-line no-shadow
export enum FontWeight {
  Normal = 400,
  Bold = 700,
}

// eslint-disable-next-line no-shadow
export enum FontSize {
  Normal = '16px',
  Large = '24px',
}

// eslint-disable-next-line no-shadow
export enum FontFamily {
  SouthWestSans = 'south-west-sans, sans-serif',
  Arial = 'Arial, Helvetica, sans-serif',
}
